import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Typography } from '@mui/material';
import { format } from 'date-fns';
import { es, enUS, fr } from 'date-fns/locale';
import esLocale from 'date-fns/locale/es';
import {DATE_TIME_FORMAT_NAME_MODEL} from '../Apis/functions';
import {ArrowLeftIcon, ArrowRightIcon} from './buttons/IconButtons';

const localeMap = { es, en: enUS, fr };

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param currentMonth: value for the currentMonth
 * @param onMonthChange: event to change currentMonth
 *
 */
function CustomHeader(props) {
    const {
        currentMonth,
        onMonthChange,
    } = props;

    const handlePrevMonth = () => onMonthChange(new Date(currentMonth.setMonth(currentMonth.getMonth() - 1)));
    const handleNextMonth = () => onMonthChange(new Date(currentMonth.setMonth(currentMonth.getMonth() + 1)));

    /**
     * Build to header calendar
     */
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center px-1 py-1">

                <ArrowLeftIcon onClick={handlePrevMonth} width={28} height={28} className="icon-color-shades-400" />

                <Typography className='fs-14px ibl-font-w-700 font-color-general-950' className="text-capitalize">
                    {format(currentMonth, DATE_TIME_FORMAT_NAME_MODEL.MMMM_YYYY, { locale: localeMap['es'] })}
                </Typography>

                <ArrowRightIcon onClick={handleNextMonth} width={28} height={28} className="icon-color-shades-400" />

            </div>
            <div className='border-bottom-shades-300 p-0 m-0'></div>
        </div>
    );
}

/**
 *
 * @param {Function} onChange - Triggered when a date is selected. Returns an event-like object with `target.value` and `target.name`. (Required)
 * @param {string} name - Name identifier for the DateCalendar, passed through the onChange event. (Required)
 * @param {string} id - Unique ID for the DateCalendar component. Defaults to "dpc_cdc_calendar". (Required)
 * @param {Function} [shouldDisableDate] - Optional function used to disable specific dates. Receives a `Date` object and should return `true` to disable that date.
 *
 *
 * @example:
 *  <CustomDateCalendar
 *      name='dateSelected'
 *      onChange={handleChange}
 *  />
 *
 */
export default function CustomDateCalendar(
    {
        onChange,
        name,
        id="dpc_cdc_calendar",
        shouldDisableDate
    }
) {
    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={esLocale}
            localeText={{ fieldYearPlaceholder: (params) => 'A'.repeat(params.digitAmount) }}
        >
            <DateCalendar
                id={id}
                slots={{ calendarHeader: CustomHeader }}
                onChange={(e) => {
                    onChange({ target: { value: e, name: name } })
                }}
                shouldDisableDate={ shouldDisableDate ? shouldDisableDate: undefined }
            />
        </LocalizationProvider>
    );

}
